var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'model/base'], function($, core, BaseModel) {
  var CurrencyModel;
  return CurrencyModel = (function(_super) {

    __extends(CurrencyModel, _super);

    function CurrencyModel() {
      CurrencyModel.__super__.constructor.apply(this, arguments);
    }

    CurrencyModel.prototype.pathRoot = core.getConfig().apiPrefix + 'currency.json';

    CurrencyModel.prototype.defaults = function() {
      return {
        id: null,
        code: null,
        name: null
      };
    };

    return CurrencyModel;

  })(BaseModel);
});
